/**
 * Widget chrome themes used by the designer picker and new-widget defaults.
 * Colors are applied to appearance.headerBg / headerFg / bodyBg.
 */
export const WIDGET_THEMES = [
  {
    id: 'snow',
    label: 'برف',
    headerBg: '#ffffff',
    headerFg: '#0f172a',
    bodyBg: '#ffffff',
    swatch: ['#ffffff', '#0f172a'],
  },
  {
    id: 'midnight',
    label: 'نیمه‌شب',
    headerBg: '#0f172a',
    headerFg: '#f8fafc',
    bodyBg: '#ffffff',
    swatch: ['#0f172a', '#6366f1'],
  },
  {
    id: 'nord',
    label: 'نورد',
    headerBg: '#3b4252',
    headerFg: '#eceff4',
    bodyBg: '#eceff4',
    swatch: ['#3b4252', '#88c0d0'],
  },
  {
    id: 'ocean',
    label: 'اقیانوس',
    headerBg: '#0e7490',
    headerFg: '#ecfeff',
    bodyBg: '#f0fdfa',
    swatch: ['#0e7490', '#14b8a6'],
  },
  {
    id: 'forest',
    label: 'جنگل',
    headerBg: '#14532d',
    headerFg: '#dcfce7',
    bodyBg: '#f0fdf4',
    swatch: ['#14532d', '#22c55e'],
  },
  {
    id: 'sunset',
    label: 'غروب',
    headerBg: '#9a3412',
    headerFg: '#fff7ed',
    bodyBg: '#fff7ed',
    swatch: ['#9a3412', '#f97316'],
  },
  {
    id: 'royal',
    label: 'نیلی',
    headerBg: '#3730a3',
    headerFg: '#eef2ff',
    bodyBg: '#eef2ff',
    swatch: ['#3730a3', '#818cf8'],
  },
  {
    id: 'rose',
    label: 'رز',
    headerBg: '#9f1239',
    headerFg: '#fff1f2',
    bodyBg: '#fff1f2',
    swatch: ['#9f1239', '#fb7185'],
  },
  {
    id: 'graphite',
    label: 'گرافیت',
    headerBg: '#334155',
    headerFg: '#f8fafc',
    bodyBg: '#f8fafc',
    swatch: ['#334155', '#94a3b8'],
  },
];

/** Default chrome for newly created widgets (Linear / Vercel-style dark header). */
export const DEFAULT_WIDGET_APPEARANCE = {
  themeId: 'midnight',
  headerBg: '#0f172a',
  headerFg: '#f8fafc',
  bodyBg: '#ffffff',
  showHeader: true,
  showBorder: true,
  showPadding: true,
  fitContent: false,
};

export const NAKED_WIDGET_CHROME = {
  showHeader: false,
  showBorder: false,
  showPadding: false,
  fitContent: true,
};

export const FRAMED_WIDGET_CHROME = {
  showHeader: true,
  showBorder: true,
  showPadding: true,
  fitContent: false,
};

function chromeFrom(prev = {}) {
  return {
    showHeader: prev.showHeader !== false,
    showBorder: prev.showBorder !== false,
    showPadding: prev.showPadding !== false,
    fitContent: !!prev.fitContent,
  };
}

export function isNakedWidgetChrome(appearance = {}) {
  return appearance.showHeader === false
    && appearance.showBorder === false
    && appearance.showPadding === false
    && appearance.fitContent === true;
}

export function applyNakedWidgetChrome(appearance = {}, naked) {
  return {
    ...(appearance || {}),
    ...(naked ? NAKED_WIDGET_CHROME : FRAMED_WIDGET_CHROME),
  };
}

export function appearanceFromTheme(theme, prev = {}) {
  if (!theme) return { ...DEFAULT_WIDGET_APPEARANCE, ...chromeFrom(prev) };
  return {
    ...chromeFrom(prev),
    themeId: theme.id,
    headerBg: theme.headerBg,
    headerFg: theme.headerFg,
    bodyBg: theme.bodyBg,
  };
}

export function matchWidgetTheme(appearance = {}) {
  const id = appearance.themeId;
  if (id) return WIDGET_THEMES.find((t) => t.id === id) || null;
  return WIDGET_THEMES.find((t) => (
    t.headerBg === appearance.headerBg
    && t.headerFg === appearance.headerFg
    && t.bodyBg === appearance.bodyBg
  )) || null;
}
